module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bubbleBath_e60039.png";